import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    back: ''
  },
  getters: {
    getHistoryBack: state => {
      return state.back
    },
    setHistoryBack: state => url => {
      state.back = url
    }
  },
  mutations: {
  },
  actions: {

  }
})